module.exports = __webpack_public_path__ + "img/test.c58e4651.png";